import { render, staticRenderFns } from "./WorkspaceSettings.pug?vue&type=template&id=59b3392f&lang=pug&external"
import script from "./WorkspaceSettings.js?vue&type=script&lang=js&external"
export * from "./WorkspaceSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports